import GlobalSocketModel from 'models/sockets/global-socket-model';
import { handleActions } from 'redux-actions';
import {
  initGlobalSocketIOSocketClient,
  setGlobalSocketClientAction,
  clearGlobalSocketClientInStore,
  stopGlobalSocketConnection,
} from 'store/actions/global-socket-actions';
import { setGlobalSocketDisconnectAction } from 'store/actions/action-creators';

export default handleActions(
  {
    [initGlobalSocketIOSocketClient]: (globalSocket, { payload }) => {
      const { geoCode, environment, dispatch, currentUser } = payload;
      return globalSocket.init({ geoCode, environment, dispatch, currentUser });
    },
    [setGlobalSocketClientAction]: (globalSocket, { payload }) => {
      return globalSocket.setGlobalSocketClients(payload);
    },
    [setGlobalSocketDisconnectAction]: (globalSocket, { payload }) => {
      return globalSocket.setGlobalSocketDisconnect(payload);
    },
    [stopGlobalSocketConnection]: (globalSocket) => {
      return globalSocket.stopGlobalSocketConnection();
    },
    [clearGlobalSocketClientInStore]: () => {
      return new GlobalSocketModel();
    },
  },
  new GlobalSocketModel(),
);
